var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCategory = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.5 17a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1zm14 0a.5.5 0 0 1 0 1h-11a.5.5 0 0 1 0-1zm-14-5a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1zm14 0a.5.5 0 0 1 0 1h-11a.5.5 0 0 1 0-1zm-14-5a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1zm14 0a.5.5 0 0 1 0 1h-11a.5.5 0 0 1 0-1z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.5 17a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1zm14 0a.5.5 0 0 1 0 1h-11a.5.5 0 0 1 0-1zm-14-5a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1zm14 0a.5.5 0 0 1 0 1h-11a.5.5 0 0 1 0-1zm-14-5a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1zm14 0a.5.5 0 0 1 0 1h-11a.5.5 0 0 1 0-1z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCategory);
export default ForwardRef;